import React from 'react';
import { connect } from 'react-redux';

import history from '../../history';
import { signOut } from '../../actions/authAction';
import userImg from '../../images/user.png';
import { setName, setEmail, setRole } from '../../actions/authAction';
import { resetDoa } from '../../actions/doaAction';
import settingsImg from '../../images/settings.png';
import uploadfileImg from '../../images/uploadfile.png';
import unlockImg from '../../images/unlocked.png';

class Header extends React.Component {
    state={
        active:false
    };

    onSignOut() {
        this.props.resetDoa();
        this.props.setEmail('');
        this.props.setName('');
        this.props.setRole({});
        localStorage.removeItem('username');
        localStorage.removeItem('password');
        this.props.signOut();
        history.push('/');
    }
    onToggle(){
        this.setState({active:!this.state.active});
    }
    render() {
        return (
                <nav className="navbar bg-red" role="navigation" aria-label="main navigation">
                    <div className="navbar-brand">
                        <img style={{ width: '40px', height: '40px', margin: '5px' }} src={userImg} alt="" />
                        {this.props.auth !== undefined &&
                            <div className="flex-v flex-center">
                                <h3 className="has-text-white-bis mr-8 ml-8">{this.props.auth.name}</h3>
                                {/* <h5 className="has-text-white-bis mr-8 ml-8">{this.props.auth.role.RoleName}</h5> */}
                            </div>
                        }
                        <a role="button" className={`navbar-burger has-text-white-bis ${this.state.active ? "is-active" : ""}`} onClick={() => this.onToggle()} aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        </a>
                    </div>

                    <div id="navbarBasicExample" className={`navbar-menu bg-red ${this.state.active ? "is-active" : ""}`}>
                        <div className="navbar-start">
                            
                        </div>

                        <div className="navbar-end">
                           
                            {(this.props.auth.isAdmin || this.props.auth.isEditor || this.props.auth.isApprover) && 
                                
                                <div className="navbar-item has-dropdown is-hoverable bg-red">
                                    <a className="navbar-link is-arrowless bg-red has-text-white-bis">
                                        Search Request
                                    </a>
                                    <div className="navbar-dropdown bg-red">
                                        <a onClick={() => history.push('/Search/Request/Inbox')} className="navbar-item has-text-white-bis">
                                            Inbox
                                        </a>
                                        <a onClick={() => history.push('/Search/Request/History')} className="navbar-item has-text-white-bis">
                                            History
                                        </a>
                                        {this.props.auth.isAdmin && 
                                        <a onClick={() => history.push('/Search/All')} className="navbar-item has-text-white-bis">
                                            All Request
                                        </a>}
                                    </div>
                                </div>
                                }
                            {/* {(this.props.auth.isAdmin || this.props.auth.isEditor ) && 
                                <a onClick={() => history.push('/Upload/Doa')} className="navbar-item has-text-white-bis">
                                    Upload Doa
                                </a>} */}
                           
                            
                                {this.props.auth.isAdmin && 
                                <a onClick={() => history.push('/Permission/Group')} className="navbar-item has-text-white-bis">
                                    Permission
                                </a>}
                                {this.props.auth.isAdmin && 
                                <a onClick={() => history.push('/Configuration')} className="navbar-item has-text-white-bis">
                                    Configuration
                                </a>}
                                {this.props.auth.isAdmin && 
                                <div className="navbar-item has-dropdown is-hoverable bg-red">
                                    <a className="navbar-link is-arrowless bg-red has-text-white-bis">
                                        Upload
                                    </a>
                                    <div className="navbar-dropdown bg-red">
                                        <a onClick={() => history.push('/Upload/AllinBook')} className="navbar-item has-text-white-bis">
                                            Upload All in Book
                                        </a>
                                        <a onClick={() => history.push('/Upload/User')} className="navbar-item has-text-white-bis">
                                            Upload User
                                        </a>
                                        <a onClick={() => history.push('/Upload/Organization')} className="navbar-item has-text-white-bis">
                                            Upload Organization
                                        </a>
                                        <a onClick={() => history.push('/Upload/Employee')} className="navbar-item has-text-white-bis">
                                            Upload Employee(old)
                                        </a>
                                    </div>
                                </div>
                                } 
                                {(this.props.auth.isAdmin || this.props.auth.isEditor) && 
                                <a onClick={() => history.push('/Encodetext')} className="navbar-item has-text-white-bis">
                                    Encode text
                                </a>}
                                {this.props.auth.isAdmin && 
                                <a onClick={() => history.push('/settings/release')} className="navbar-item has-text-white-bis">
                                    Release
                                </a>}
                            <div className="navbar-item">
                                <div className="buttons">
                                    <button onClick={() => this.onSignOut()} className="button is-small is-danger">Sign out</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            // <div className="flex-v">
            //     <div className="flex-h flex-between pr-16 pl-16 pt-8 pb-8 bg-red">
            //         <img style={{ width: '40px', height: '40px' }} src={userImg} alt="" />
            //         {this.props.auth !== undefined &&
            //             <div className="flex-v flex-center">
            //                 <h3 className="has-text-white-bis mr-8 ml-8">{this.props.auth.name}</h3>
            //                 <h5 className="has-text-white-bis mr-8 ml-8">{this.props.auth.role.RoleName}</h5>
            //             </div>
            //         }
            //         <div className="flex-h flex-center">
            //             {/* {(this.props.auth.role.Insert || this.props.auth.role.Update || this.props.auth.role.Delete) &&
            //                 <img onClick={() => history.push('/Checkout/Doa')} style={{ width: '20px', cursor: 'pointer' }} className="mr-8" src={unlockImg} alt="" />}
            //             {(this.props.auth.role.Insert || this.props.auth.role.Update || this.props.auth.role.Delete) &&
            //                 <img onClick={() => history.push('/Upload/Doa')} style={{ width: '20px', cursor: 'pointer' }} className="mr-8" src={uploadfileImg} alt="" />} */}
            //             {(this.props.auth.role.Insert || this.props.auth.role.Update || this.props.auth.role.Delete) &&
            //                 <img onClick={() => history.push('/Permission/Group')} style={{ width: '20px', cursor: 'pointer' }} className="mr-8" src={settingsImg} alt="" />} 
            //             {this.props.auth.role.Release &&
            //                 <img onClick={() => history.push('/settings/release')} style={{ width: '20px', cursor: 'pointer' }} className="mr-8" src={settingsImg} alt="" />}
            //             <button onClick={() => this.onSignOut()} className="button is-small is-danger">sign out</button>
            //         </div>
            //     </div>
            //     <div className="flex-h">
            //         <div className="flex-1" style={{ backgroundColor: '#ff3a42', height: '4px' }}></div>
            //         <div className="flex-1" style={{ backgroundColor: '#fcae00', height: '4px' }}></div>
            //         <div className="flex-1" style={{ backgroundColor: '#282e43', height: '4px' }}></div>
            //         <div className="flex-1" style={{ backgroundColor: '#00cfe3', height: '4px' }}></div>
            //     </div>
            // </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps, {
    signOut,
    setEmail,
    setName,
    resetDoa,
    setRole
})(Header);